import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Dashbaord } from './dashbaord';
import { HttpService } from '@core/services';


@Injectable({
  providedIn: 'root',
})
export class OpportunityService {
  constructor(
    private readonly _httpClient: HttpService,
  ) { }

  getOpportunity(): Observable<Dashbaord[]> {
    return this._httpClient.get('rest/v1/opportunity?select=*');
  }
}
